import Vue from 'vue'
import VtPersonnelProfileImage from '@/components/common/vt-personnel-profile-image/vt-personnel-profile-image.vue'
Vue.component('VtPersonnelProfileImage', VtPersonnelProfileImage)
